[
  "Bloodhound", "Gibraltar", "Lifeline", "Pathfinder", "Wraith", "Bangalore", "Caustic",
  "Mirage", "Octane", "Wattson", "Crypto", "Revenant", "Loba", "Rampart", "Horizon",
  "Fuse", "Valkyrie", "Seer", "Ash", "Mad Maggie", "Newcastle", "Vantage", "Catalyst",
  "Ballistic", "Conduit", "Alter", "Sparrow", "Axle"
]
